import URL from './url'
import http from '@/utils/httpUtils'

import ding from './ding'
import fishnet from './fishnet'
import leave from './leave'
import attendance from './attendance'
import dorm from './dorm'
import temperature from './temperature'
import supply from './supply'
import screen from './screen'
import flexleave from './flexleave'
import classcard from './classcard'
import afterschool from './afterschool'
import elective from './elective'
import classevaluation from './classevaluation'
import schedule from './schedule'
import recipes from './recipes'
import common from './common'
import substitute from './substitute'
import guardian from './guardian'
import studentSign from './studentSign'
import magic from './magic'
import entryInformation from './entryInformation.js'
import expireSku from './expireSku' // 套餐到期
import vehicleManage from './vehiclemanage'
import security from './security'
import behavior from './behavior'
import wechat from './wechat'
import opendoor from './opendoor'
import atschool from './atschool'
import other from './other'
import meal from './meal'
import familycall from './familycall'
import rights from './rights'

let API = {}

API = Object.assign(
  API,
  {
    /* 微信相关接口-开始 */
    // 获取微信公众号accessToken
    getWechatAccessToken(postData) {
      return http.get(URL.API_WECHAT_GET_AUTH_ACCESS_TOKEN, {
        ...postData,
        appType: 3,
        smallProgramType: 3
      })
    },
    // 获取微信公众号用户信息
    getWechatUserInfo(postData) {
      return http.post(URL.API_WECHAT_GET_USER_INFO, {
        ...postData,
        appType: 3,
        smallProgramType: 3
      })
    },
    // 获取或创建账号
    getAccountId(postData) {
      return http.get(URL.API_WECHAT_REGISTER_ACCOUNT, {
        ...postData,
        appType: 3,
        smallProgramType: 3
      })
    }
  },
  /* 微信相关接口-结束 */
  ding,
  fishnet,
  leave,
  attendance,
  dorm,
  temperature,
  supply,
  screen,
  flexleave,
  classcard,
  afterschool,
  elective,
  classevaluation,
  schedule,
  substitute,
  recipes,
  common,
  guardian,
  studentSign,
  magic,
  entryInformation,
  expireSku, // 套餐到期
  vehicleManage,
  security,
  behavior,
  opendoor,
  atschool,
  wechat,
  other,
  meal,
  familycall,
  rights
)

export default API
